/**
 * Redbasil Tru Membership Guard — Store-wide
 * Variant ID: 45090784116806
 * Discount code: RBT-MEMBER10
 */
(function () {
  const { variantId, isLoggedIn, isActiveMember, loginUrl } = window.RBT_MEMBERSHIP || {};
  if (!variantId) return;

  const VARIANT_ID = String(variantId);

  // ── Helpers ───────────────────────────────────────────────────────────────

  function isMembershipVariant(id) {
    return String(id) === VARIANT_ID;
  }

  async function cartContainsMembership() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items.some(item => isMembershipVariant(item.variant_id));
  }

  // function redirectToLogin() {
  //  window.location.href = loginUrl + '?return_url=' + encodeURIComponent(window.location.pathname);
  //}

  function showError(message, formEl) {
    const productFormEl = formEl?.closest('product-form');
    if (productFormEl && typeof productFormEl.handleErrorMessage === 'function') {
      productFormEl.handleErrorMessage(message);
    } else {
      alert(message);
    }
  }

  // ── Core add-to-cart logic (used by banner + any programmatic add) ─────────

  async function tryAddMembership(onSuccess) {
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    if (isActiveMember) {
      alert('You already have an active Redbasil Tru membership.');
      return;
    }
    const inCart = await cartContainsMembership();
    if (inCart) {
      alert('Membership is already in your cart.');
      return;
    }
    const res = await fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
    });
    if (res.ok && typeof onSuccess === 'function') onSuccess();
  }

  // ── 1. Fetch intercept ────────────────────────────────────────────────────

  const _fetch = window.fetch;
  window.fetch = async function (input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';

    if (url.includes('/cart/add')) {
      let variantId = null;
      let body = init.body;

      if (body instanceof FormData) {
        variantId = body.get('id');
      } else {
        try { body = typeof body === 'string' ? JSON.parse(body) : body; } catch (_) {}
        if (Array.isArray(body?.items)) {
          variantId = body.items.find(i => isMembershipVariant(i.id))?.id || null;
        } else {
          variantId = body?.id || null;
        }
      }

      if (variantId && isMembershipVariant(variantId)) {
        if (!isLoggedIn) {
          redirectToLogin();
          return new Response(JSON.stringify({ status: 401, description: 'Login required.' }), { status: 401 });
        }
        if (isActiveMember) {
          return new Response(
            JSON.stringify({ status: 422, description: 'You already have an active Redbasil Tru membership.' }),
            { status: 422, headers: { 'Content-Type': 'application/json' } }
          );
        }
        const inCart = await cartContainsMembership();
        if (inCart) {
          return new Response(
            JSON.stringify({ status: 422, description: 'Membership is already in your cart.' }),
            { status: 422, headers: { 'Content-Type': 'application/json' } }
          );
        }
      }

      return _fetch.apply(this, [input, init]);
    }

    if (url.includes('/cart/change')) {
      let body = init.body;
      try { body = typeof body === 'string' ? JSON.parse(body) : body; } catch (_) {}
      const lineIndex = body?.line;
      const lineInput =
        document.getElementById(`Quantity-${lineIndex}`) ||
        document.getElementById(`Drawer-quantity-${lineIndex}`);
      const isMemLine = lineInput && isMembershipVariant(lineInput.dataset.quantityVariantId);
      if (isMemLine && body?.quantity > 1) {
        body.quantity = 1;
        init.body = JSON.stringify(body);
      }
      return _fetch.apply(this, [input, init]);
    }

    return _fetch.apply(this, [input, init]);
  };

  // ── 2. Form submit intercept ──────────────────────────────────────────────

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form.getAttribute('data-type') !== 'add-to-cart-form' &&
        !form.action?.includes('/cart/add')) return;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !isMembershipVariant(variantInput.value)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!isLoggedIn) { redirectToLogin(); return; }
    if (isActiveMember) { showError('You already have an active Redbasil Tru membership.', form); return; }

    cartContainsMembership().then(inCart => {
      if (inCart) {
        showError('Membership is already in your cart.', form);
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      } else {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
        const productFormEl = form.closest('product-form');
        if (productFormEl && typeof productFormEl.onSubmitHandler === 'function') {
          productFormEl.onSubmitHandler(new Event('submit', { bubbles: true, cancelable: true }));
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    });
  }, true);

  // ── 3. Membership banner CTA ──────────────────────────────────────────────
  /* ====
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-membership-cta]');
    if (!btn) return;
    e.preventDefault();
    tryAddMembership(function () {
      // Refresh cart drawer — update event name if yours differs
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  });
  ===== */
  // ── 4. Quantity lock ──────────────────────────────────────────────────────

  function lockMembershipInputs() {
    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach(input => {
      const vid = input.dataset.quantityVariantId ||
        input.closest('[data-variant-id]')?.dataset.variantId;
      if (!isMembershipVariant(vid)) return;
      input.setAttribute('max', '1');
      if (parseInt(input.value, 10) > 1) input.value = 1;
      const plusBtn = input.closest('quantity-input')?.querySelector('[name="plus"]');
      if (plusBtn && parseInt(input.value, 10) >= 1) {
        plusBtn.setAttribute('disabled', '');
        plusBtn.style.cssText = 'opacity:0.4;cursor:not-allowed;pointer-events:none;';
      }
    });
  }

  lockMembershipInputs();
  new MutationObserver(lockMembershipInputs).observe(document.body, { childList: true, subtree: true });

  // ── 5. Plus button click block ────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity__button[name="plus"]');
    if (!btn) return;
    const input = btn.closest('quantity-input')?.querySelector('.quantity__input');
    if (!input) return;
    const vid = input.dataset.quantityVariantId ||
      input.closest('[data-variant-id]')?.dataset.variantId;
    if (!isMembershipVariant(vid)) return;
    if (parseInt(input.value, 10) >= 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

})();



